import { AssessmentResults } from 'types';
import { objectEntries } from 'utils/objectEntries';

export const getTop3Skills = (results: AssessmentResults, lang: Record<string, any>) => {
  return objectEntries(results.cognitive)
    .filter((t): t is [keyof typeof results.cognitive, number] => t[1] !== null)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 3)
    .map(([id, score]) => ({
      id,
      score,
      name: lang.cards.cognitive[id].name,
    }));
};
